import axiosInstance from '../../api/axios';

/**
 * Isolated Assessment Reports edit API — overrides an existing assessment JSON blob.
 * Does not share helpers with the Materiality wizard create flow.
 */
export async function updateMaterialityAssessmentReport(assessmentId, payload) {
  const response = await axiosInstance.put(`/api/materiality-assessments/${assessmentId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}
